// extracted by mini-css-extract-plugin
module.exports =  {"listingImg":"listingImg__-20ID","listingInfo":"listingInfo__mOzqZ","listingId":"listingId__ISF2W","listingName":"listingName__IBzO0","title":"title__FPuWj"};